import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Input, Popover } from 'antd';
import UIText from './uiText';
import UIValue from './uiValue';
import UIValidation from './uiValidation';
function UIFieldComponent(props) {
    const [value, setValue] = useState(props.value || '');
    useEffect(() => {
        setValue(props.value || '');
    }, [props.value]);
    const handleChange = (event) => {
        setValue(event.target.value);
        props.onChange(event);
    };
    if (props.text === null) {
        return (_jsxs("div", { style: { display: 'flex', marginBottom: '10px', ...props.styling }, children: [props.title && (_jsx("label", { style: {
                        marginRight: '16px',
                        whiteSpace: 'nowrap',
                        width: '140px',
                        textAlign: 'left',
                    }, children: props.title })), _jsx(Input, { style: { flex: 1 }, maxLength: props.maxLength, value: value, onChange: handleChange, readOnly: props.readonly })] }));
    }
    else {
        return (_jsxs("div", { style: { display: 'flex', marginBottom: '16px', ...props.styling }, children: [_jsx("label", { style: {
                        marginRight: '16px',
                        whiteSpace: 'nowrap',
                        width: '140px',
                        textAlign: 'left',
                    }, children: props.title }), _jsx(Input, { style: { flex: 1 }, maxLength: props.maxLength, onChange: handleChange, value: value, readOnly: props.readonly, addonAfter: _jsx(Popover, { content: props.text, trigger: "click", overlayStyle: { width: 400, height: 300 }, children: _jsx(InfoCircleOutlined, { style: { cursor: 'pointer' } }) }) })] }));
    }
}
export default class UIField extends UIValue {
    title;
    maxLength;
    text;
    style;
    readonly;
    constructor(s) {
        super(s);
        this.title = this.getProperty('title');
        if ('text' in s) {
            this.text = new UIText(s);
        }
        this.style = this.getProperty('style', '');
        this.maxLength = Number(this.getProperty('maxLength'));
        this.readonly = this.getProperty('readonly', false);
    }
    getComponent() {
        const onChange = (event) => {
            this.value = event.target.value;
        };
        const text = this.text !== undefined ? this.text.getComponent() : null;
        const props = {
            maxLength: this.maxLength,
            title: this.title,
            text: text,
            onChange: onChange,
            value: this.value,
            readonly: this.readonly,
            styling: this.style,
        };
        return (_jsx(UIValidation, { error: this.error, children: _jsx(UIFieldComponent, { ...props }) }));
    }
}
//# sourceMappingURL=uiField.js.map